module.exports = __webpack_public_path__ + "static/media/sent.341cf710.svg";